export const BW_MOTION = {
  duration: {
    immediate: 0,
    short: 120,
    medium: 200,
    long: 320,
  },
  reduced: {
    immediate: 0,
    short: 0,
    medium: 0,
    long: 0,
  },
} as const;

export type BwMotion = typeof BW_MOTION;
